import React, {PropTypes} from 'react';
import {Route, Redirect} from 'react-router-dom';
import {sessionKey} from './../store/cookies.js';

// TODO PropTypes validation for component is throwing error so overlooking at the moment
const MatchHydrate = ({ data, authenticate, component: Component, ...rest }) => (
	<Route {...rest} render={props => (
			authenticate && !sessionKey() ? (
				<Redirect to={{ pathname: '/login', state: { from: props.location } }} />
			) : (
				<Component data={data} {...props} />
			)
		)}
	/>
);

MatchHydrate.propTypes = {
	data: PropTypes.object,
	authenticate: PropTypes.bool,
	location: PropTypes.object,
	component: PropTypes.func
};
/*
MatchHydrate.contextTypes = {
  router: React.PropTypes.object
}*/

export default MatchHydrate;



// WEBPACK FOOTER //
// ./mobile-core/src/components/match-hydrate.js